import { join } from 'lodash'

const toCommas = strings => join(strings, ', ')

export default toCommas
